interface CachedTextMetrics {
    width: number;
    height: number;
    offsetY: number;
}

/**
 * Кэш метрик текста.
 * Тексты нотификаций статичны, поэтому кэш не растёт бесконечно.
 * При добавлении динамических текстов — добавить LRU или ограничение размера.
 */
const textMetricsCache = new Map<string, CachedTextMetrics>();

// Сброс кэша после загрузки шрифтов
if (typeof document !== 'undefined' && document.fonts) {
    document.fonts.ready.then(() => {
        textMetricsCache.clear();
    });
}

/**
 * Получает метрики текста с кэшированием
 */
export function getTextMetrics(ctx: CanvasRenderingContext2D, text: string, font: string): CachedTextMetrics {
    const cacheKey = `${font}|${text}`;

    const cached = textMetricsCache.get(cacheKey);
    if (cached) {
        return cached;
    }

    ctx.save();
    ctx.font = font;
    const metrics = ctx.measureText(text);
    const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
    ctx.restore();

    const result: CachedTextMetrics = {
        width: metrics.width,
        height,
        offsetY: -height / 2,
    };

    textMetricsCache.set(cacheKey, result);
    return result;
}
